import { useState } from 'react'

import Grid from '@mui/material/Grid'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'

import { ProductIcon } from '@components/ProductIcon'
import { disciplines, getProductsOrDefault } from '@util/discipline'
import { createBadge } from '@util/kpi-util'

import { SidebarLayoutDrawer } from '../../../theme/components/SidebarLayoutDrawer'
import type { AansluitObject as AansluitObjectType } from '../../project/types/AansluitObject'
import type { Project } from '../../project/types/Project'

import { Disciplines } from './Disciplines'

const objectIdFilter = (id) => (object) => object.objectID === id

interface Props {
  project: Project
  aansluitObject: AansluitObjectType
}

export const AansluitObject = ({ project, aansluitObject }: Props) => {
  const [selectedProduct, setSelectedProduct] = useState<any>({})
  const [drawer, setDrawer] = useState(false)
  const getProducts = getProductsOrDefault(aansluitObject.produkten)

  const toggleDrawer = (open) => (product?: any) => () => {
    setSelectedProduct(product || {})
    setDrawer(open)
  }

  return (
    <TableRow key={aansluitObject.objectID} tabIndex={-1}>
      <TableCell>
        <Grid container direction="row">
          {disciplines
            .reduce(
              (curr, disciplineCode) =>
                curr.concat(getProducts(disciplineCode)),
              [],
            )
            .map((product: any) => (
              // TODO Add kpi badges
              <ProductIcon
                key={`${aansluitObject.objectID}${product.disciplineCode}${product.netbeheerderCode}`}
                badge={createBadge(product.kpi)}
                product={product}
                onClick={toggleDrawer(true)(product)}
              />
            ))}
        </Grid>
      </TableCell>
      <TableCell>{aansluitObject.objectID}</TableCell>
      <TableCell>{aansluitObject.objectTypeLabel}</TableCell>
      <TableCell>{aansluitObject.adres}</TableCell>
      <TableCell>{aansluitObject.statusText}</TableCell>
      <TableCell />
      <SidebarLayoutDrawer
        open={drawer}
        onClose={toggleDrawer(false)()}
        title={selectedProduct.disciplineLabel}
      >
        <Disciplines
          project={project}
          product={selectedProduct}
          objectFilter={objectIdFilter(aansluitObject.objectID)}
        />
      </SidebarLayoutDrawer>
    </TableRow>
  )
}
